<mat-card class="p-0">
    <mat-tab-group [selectedIndex]="0">
        <!-- Education Tab -->
        <mat-tab label="Education">

            <form [formGroup]="addDegreeCourceForm">
                <div class="row">
                    <div class="col-md-4">
                        <div class="form-group">
                            <label class="label-cls">Degree</label>
                            <p-dropdown class="w-100" [options]="degreeType" formControlName="degreetype"
                                optionLabel="name" optionValue="id" placeholder="Select Degree"
                                appendTo="body"></p-dropdown>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="form-group">
                            <label class="label-cls">Field of study</label>
                            <input class="im-input mw-100" formControlName="fieldOfStudy" type="text" form
                                placeholder="Enter" />
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="form-group">
                            <label class="label-cls">University Name</label>
                            <input class="im-input mw-100" formControlName="universityName" type="text" form
                                placeholder="Enter" />
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-6">
                        <div class="form-group">
                            <label class="label-cls">Address Line 1</label>
                            <input class="im-input mw-100" maxlength="99" formControlName="addressLine1" type="text"
                                form placeholder="Enter" />
                        </div>
                    </div>
                    <div class="col-6">
                        <div class="form-group">
                            <label class="label-cls">Address Line 2</label>
                            <input class="im-input mw-100" maxlength="99" formControlName="addressLine2" type="text"
                                form placeholder="Enter" />
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-3">
                        <div class="form-group">
                            <label class="label-cls">Country</label>
                            <p-dropdown class="w-100" [options]="listCountry" formControlName="countryCode"
                                optionLabel="countryName" optionValue="countryCode" placeholder="Select Country"
                                (onChange)="handleCountryChange()" appendTo="body" [filter]="true" filterBy="countryName"></p-dropdown>
                        </div>
                    </div>
                    <div class="col-3" *ngIf="listStates.length > 0">
                        <div class="form-group">
                            <label class="label-cls">State</label>
                            <p-dropdown class="w-100" [options]="listStates" formControlName="stateProvinceCode"
                                optionLabel="stateProvinceName" optionValue="stateProvinceCode"
                                placeholder="Select State" appendTo="body" [filter]="true" filterBy="stateProvinceName"></p-dropdown>
                        </div>
                    </div>
                    <div class="col-3" *ngIf="listStates.length <= 0">
                        <div class="form-group">
                            <label class="label-cls">State</label>
                            <input class="im-input mw-100" formControlName="stateProvinceName" type="text" placeholder="State" />
                        </div>
                    </div>
                    <div class="col-3">
                        <div class="form-group">
                            <label class="label-cls">City</label>
                            <input class="im-input mw-100" formControlName="city" type="text" form
                                placeholder="Enter" />
                        </div>
                    </div>
                    <div class="col-3">
                        <div class="form-group">
                            <label class="label-cls">
                                ZIP / Postalcode
                            </label>
                            <input class="im-input mw-100" formControlName="postCode" type="text" form
                                placeholder="Enter" maxlength="10" />
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12">
                        <div class="form-group">
                            <button class="btn btn-success" (click)="saveDegreeDetails()">
                                <i class="fa fa-floppy-o" aria-hidden="true"></i> Save & More
                            </button>
                        </div>
                    </div>
                </div>
            </form>
            <div class="table-section">Education</div>

            <table mat-table #table [dataSource]="dataSource" class="full-width-table" matSort aria-label="Elements">

                <ng-container matColumnDef="degreeType">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Degree</th>
                    <td mat-cell *matCellDef="let row">{{row.degreeType?.description}}</td>
                </ng-container>

                <ng-container matColumnDef="fieldOfStudy">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Field Of Study</th>
                    <td mat-cell *matCellDef="let row">{{row.fieldOfStudy}}</td>
                </ng-container>

                <ng-container matColumnDef="countryName">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Country</th>
                    <td mat-cell *matCellDef="let row">{{row.country?.countryName}}</td>
                </ng-container>

                <ng-container matColumnDef="stateName">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>State</th>
                    <td mat-cell *matCellDef="let row">{{row.stateProvinceName ? row.stateProvinceName : row.stateProvinceCode}}</td>
                </ng-container>

                <ng-container matColumnDef="university">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>University</th>
                    <td mat-cell *matCellDef="let row">{{row.university}}</td>
                </ng-container>

                <ng-container matColumnDef="id">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Action</th>
                    <td mat-cell *matCellDef="let row">
                        <i class="fa fa-pencil" aria-hidden="true" title="Edit" (click)="editEducation(row)"></i>
                        <i class="fa fa-trash-o" aria-hidden="true" title="Delete" (click)="deleteEducation(row)"></i>
                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

            </table>

            <div class="no-record" *ngIf="dataSource.length === 0">No record found</div>
        </mat-tab>
        <!-- Documnet Upload Tab -->
        <mat-tab label="Upload Documents" [disabled]="!addDegreeCourceForm.get('id').value">
            <div class="row">
                <div class="col-12">
                    <app-file-upload (fileUploadSuccess)="fileUploadSuccess()" style="width: 100%"
                        [configurations]="degreeFileUploadConfigurations"></app-file-upload>
                </div>
            </div>
        </mat-tab>
    </mat-tab-group>
</mat-card>